import React from "react";
import Container from "@/components/marketing/Container";
import { Clock, CalendarClock, Link2, FileText, Newspaper, Briefcase } from "lucide-react";
import SectionHeading from "@/components/marketing/SectionHeading";
import Reveal from "@/components/marketing/Reveal";

const ITEMS = [
  { icon: Clock, label: "Same-day submission", desc: "Submitted to the publication the same day." },
  { icon: CalendarClock, label: "Turnaround upfront", desc: "Expected timing shown before you order." },
  { icon: Link2, label: "Link type upfront", desc: "Dofollow, nofollow, or sponsored, disclosed per outlet." },
  { icon: FileText, label: "Formats accepted", desc: "Press releases, thought leadership, op-eds, guest posts." },
  { icon: Newspaper, label: "Choose your outlets", desc: "One publication or as many as you want." },
  { icon: Briefcase, label: "Any industry", desc: "Wide acceptance, including niche and restricted sectors." },
];

export default function WhatsIncluded() {
  return (
    <section className="py-7 sm:py-9 lg:py-12">
      <Container>
        <Reveal>
          <SectionHeading
            tag="WHAT'S INCLUDED"
            title="Full transparency, before you pay"
            subtitle="Placements vary by publication, so we show you exactly what you get before you commit."
          />
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-5 max-w-5xl mx-auto">
          {ITEMS.map((item, index) => (
            <Reveal variant="card" delay={index * 0.08} key={item.label}>
              <div className="flex items-start gap-3">
                <div className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[rgba(139,92,246,0.1)] shrink-0">
                  <item.icon className="w-4 h-4 text-[#7c3aed]" strokeWidth={1.75} />
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm font-[650] text-[#1c1c20] leading-tight">{item.label}</h3>
                  <p className="text-xs text-[#8e8e96] leading-snug mt-0.5">{item.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}